import { UxGameController } from './ux-game-controller';
import { Observable } from 'rxjs';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { GameId } from 'src/app/model/game/game-id';
import { BlocksUxGameListener } from '../listeners/blocks-ux-game-listener';
import { BlocksPreloadScene } from 'src/games/phaserblocks/game/scenes/blocks-preload-scene';
import { BlocksMainScene } from 'src/games/phaserblocks/game/scenes/blocks-main-scene';
import { ActionBus } from 'game-logic';
import { UxGameServiceAction } from 'src/app/core/services/ux-game/ux-game-service-action';
import { BlocksApp } from 'src/games/phaserblocks/game/blocks-app';

export class BlocksUxGameController extends UxGameController {
  public override get gameId(): GameId {
    return GameId.Blocks;
  }
  public get gameMultiplier$(): Observable<number> {
    return this.blocksListener.gameMultiplier$;
  }
  public get gameLevel$(): Observable<number> {
    return this.blocksListener.gameLevel$;
  }

  private blocksListener: BlocksUxGameListener;
  private blocksMainScene: BlocksMainScene;

  constructor(
    gameListener: BlocksUxGameListener,
    gameServiceActionBus: ActionBus<UxGameServiceAction>,
    services: UxGameServices,
  ) {
    const blocksApp = new BlocksApp(services.themeService);
    const preloadScene = new BlocksPreloadScene(blocksApp, services.themeService.blocksAssetPath());
    preloadScene.setGameListener(gameListener);
    preloadScene.preloadTranslations(services.translocoService);

    const mainScene = new BlocksMainScene(blocksApp);

    super(gameListener, preloadScene, mainScene, gameServiceActionBus, services);

    this.blocksListener = gameListener;
    this.blocksMainScene = mainScene;
  }

  protected override resetGame(): void {
    super.resetGame();
    this.blocksMainScene.resetGameScene();
  }

  public override setGameVisible(isVisible: boolean): void {
    this.blocksMainScene.setGameVisible(isVisible);
  }
}
